import { BASE_URL, POPUP_BASE_URL, V2_BASE_URL } from './constants';
import { beforeUnLoadFunction } from './tools';

const servername = V2_BASE_URL;

interface fetchOptions {
  method: string;
  timeout: number;
}

function setHeader(uri: string, no_content_type?: boolean) {
  const root_path = uri.split('/')[1];
  const check_arr = ['login'];
  const target_cookie = uri == '/login/auto' ? 'auto-token' : 'a-token';
  const cookie: string | null = getCookie(target_cookie) ? getCookie(target_cookie) : null;

  const header: { [key: string]: string } = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  if (no_content_type) {
    delete header['Content-Type'];
  }

  if (cookie) {
    header['Authorization'] = `Bearer ${cookie}`;
  }

  return header;
}

function setToken(res: any) {
  const three_month_later = new Date(new Date().setMonth(new Date().getMonth() + 3));
  const one_month_later = new Date(new Date().setMonth(new Date().getMonth() + 1));

  if (res.accessToken) {
    document.cookie = `a-token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`; // 만료 코드
    document.cookie = `a-token=${res.accessToken}; expires=${three_month_later}; path=/`; // 업데이트 코드
  }
  if (res.newAccessToken) {
    document.cookie = `a-token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    document.cookie = `a-token=${res.newAccessToken}; expires=${three_month_later}; path=/`;
  }
  if (res.autoToken) {
    document.cookie = `auto-token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    document.cookie = `auto-token=${res.autoToken}; expires=${one_month_later}; path=/`;
  }

  return;
}

function checkExpiredError(res: any) {
  if (res.message == 'TokenExpiredError') {
    return true;
  }
  return false;
}

export function getCookie(type: string) {
  const cookie: string = document.cookie;
  if (cookie.length > 0) {
    const cookie_split: string[] = cookie.split(';');
    const cookie_arr: { target: string; value: string }[] = cookie_split.map(item => {
      const splited: string[] = item.split('=');

      return {
        target: splited[0].trim(),
        value: splited[1].trim(),
      };
    });

    const res_item: number = cookie_arr.findIndex(item => {
      return item.target == type;
    });

    if (cookie_arr[res_item]) {
      return cookie_arr[res_item].value;
    } else {
      return null;
    }
  }
  return null;
}

function getValidatedUri(uri: string) {
  const session_user = sessionStorage.getItem('user');
  if (session_user) {
    const user = JSON.parse(session_user);
    const splited_uri = uri.split('/').filter(item => item);
    if (splited_uri[0] == '0' && splited_uri[2] == '0') {
      splited_uri[0] = user.cid;
      splited_uri[2] = user.uid;

      return `/${splited_uri.join('/')}`;
    } else {
      return uri;
    }
  }
  return uri;
}

function setUri(uri: string) {
  let new_servername = servername;

  let new_uri = uri;
  if (uri.includes('{banner}')) {
    new_servername = POPUP_BASE_URL;
    new_uri = new_uri.replace(/{banner}/, '');
  } else if (uri.includes('{v1}')) {
    new_servername = POPUP_BASE_URL;
    new_uri = new_uri.replace(/{v1}/, '');
  } else if (uri.includes('{ims}')) {
    new_servername =
      process.env.NODE_ENV == 'production' ? 'https://super-api.irontrain.co.kr' : 'https://totapidev.irontrain.co.kr';
    new_uri = new_uri.replace(/{ims}/, '');
  } else if (uri.includes('{cf_errornotice}')) {
    new_servername = 'https://e49n33s5yk.apigw.ntruss.com/errornotice/v001/qMlXKqxEpY/json?service=cb';
    new_uri = new_uri.replace(/{cf_errornotice}/, '');
  } else if (uri.includes('{cf_hyosungerror}')) {
    new_servername = 'https://e49n33s5yk.apigw.ntruss.com/maintenance/v1/0BxS9GgTSU/json';
    new_uri = '';
  }

  const session_user = window.sessionStorage.getItem('user');
  if (session_user) {
    const json_user = JSON.parse(session_user);

    if (
      !uri.includes('/account/send/pretest') &&
      !uri.includes('/academy/tutorial') &&
      !uri.includes('/academy/funneltutorial') &&
      !location.pathname.includes('/account/sms') &&
      location.pathname.includes('/account') &&
      json_user.memtype == 'F'
    ) {
      if (
        location.pathname.includes('/account') &&
        !uri.includes('teacher/all?sort=uclass') &&
        !uri.includes('account/details/testSend') &&
        !uri.includes('academy/info')
      ) {
        if (process.env.NODE_ENV === 'production') {
          new_uri = new_uri.replace(`/${json_user.cid}/user/${json_user.uid}`, '/21848/user/1371579');
        } else {
          new_uri = new_uri.replace(`/${json_user.cid}/user/${json_user.uid}`, '/21848/user/1371579');
        }
      }
    }
  }

  return new_servername + getValidatedUri(new_uri);
}

function checkTokenError(res: any) {
  if ([403, 401].includes(res.status)) {
    window.removeEventListener('beforeunload', beforeUnLoadFunction);
    window.sessionStorage.removeItem('user');
    document.cookie = `a-token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`; // 만료 코드
    window.location.replace(`${BASE_URL}/login?auto=false`);

    alert('세션이 종료되었습니다. 다시 로그인 바랍니다.');
  }
}

// Fetch POST
export const fetchPostApi = async function (uri: string, args: object, use_vali?: boolean, opt?: RequestInit) {
  const session_user = window.sessionStorage.getItem('user');
  if (session_user) {
    const json_user = JSON.parse(session_user);
    if (json_user.pretest == 1) {
      if (
        !uri.includes('/academy/tutorial') &&
        !uri.includes('account/details/testSend') &&
        !uri.includes('/academy/funneltutorial')
      ) {
        if (uri.includes('remain')) {
          return {
            pass: true,
            message: {
              ...json_user,
              smsok: {
                data: [json_user.smsok],
              },
              alimtalkuse: {
                data: [json_user.alimtalkuse],
              },
              attendance_sms_abs_msg: `${json_user.attendance_sms_title}\r\n${json_user.attendance_sms_abs_msg}`,
              attendance_sms_att_msg: `${json_user.attendance_sms_title}\r\n${json_user.attendance_sms_att_msg}`,
            },
          };
        } else if (!uri.includes('/account/send/pretest')) {
          return {
            pass: true,
            message: [{ rname: '체험 전용', rid: 1 }],
          };
        }
      }
    }
  }
  const { headers: optHeaders, ...restOpt } = opt ?? {};
  const mergedHeaders: HeadersInit = {
    ...setHeader(uri),
    ...(optHeaders as HeadersInit),
  };
  const response = await fetch(setUri(uri), {
    method: 'POST',
    headers: mergedHeaders,
    body: JSON.stringify(args),
    ...restOpt,
  });
  checkTokenError(response);
  const responseJson = await response.json();
  setToken(responseJson);
  return responseJson;
};

// Fetch GET
export const fetchGetApi = async function (uri: string, opt?: RequestInit) {
  try {
    const { headers: optHeaders, ...restOpt } = opt ?? {};
    const mergedHeaders: HeadersInit = {
      ...setHeader(uri),
      ...(optHeaders as HeadersInit),
    };
    const response = await fetch(setUri(uri), {
      method: 'GET',
      headers: mergedHeaders,
      ...restOpt,
    });

    checkTokenError(response);
    const responseJson = await response.json();
    setToken(responseJson);
    return responseJson;
  } catch (err) {
    console.log(err);
  }
};

export const fetchWithTimeout = async function (uri: string, options?: fetchOptions) {
  try {
    // const { timeout = 8000 } = options;
    let timeout = 2000;
    if (options?.timeout) {
      timeout = options.timeout;
    }

    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    const response = await fetch(setUri(uri), {
      ...options,
      signal: controller.signal,
    });
    clearTimeout(id);

    const responseJson = await response.json();
    return responseJson;
  } catch (err) {
    console.log(err);
  }
};

// Fetch POST FILES
export const fetchFileApi = async function (uri: string, args: FormData) {
  const response = await fetch(setUri(uri), {
    method: 'POST',
    headers: {
      ...setHeader(uri, true),
    },

    body: args,
  });
  checkTokenError(response);
  const responseJson = await response.json();
  return responseJson;
};
